import { ItemList } from 'orm'
import { map, get } from 'lodash'

class ActiveNotificationModelList extends ItemList {
    getEntityKey() {
        return "admin/notification_model/get_active_notification_models"
    }

    getAsOptions() {
        const items = this.getVisibleObjects()
        return map(items, function(item) {
          return { label: item.name, value: item.id }
        }
      )
    }
}

export const adminActiveNotificationModelList = new ActiveNotificationModelList("admin_active_notification_model__default")

export async function getBeneficiaryVettingNotificationModelId(dispatch, initialVisibleObjects) {
  let notificationModels = initialVisibleObjects || []

  if (!notificationModels.length) {
    await dispatch(adminActiveNotificationModelList.fetchListIfNeeded(true))
    notificationModels = adminActiveNotificationModelList.getVisibleObjects() || []
  }

  const notificationModel = notificationModels.find((item) =>
    String(get(item, 'name', '')).trim().toLowerCase().includes('beneficiary')
  )

  return get(notificationModel, 'id') || get(notificationModel, 'ref')
}
